import React from 'react';
import styled from 'styled-components';
import CoreSelect from 'gatsby-theme-core/src/components/form-elements/select';
import Wrapper from './wrapper';
import Label from './label';

const Dropdown = ({
  className,
  name,
  label = null,
  required = false,
  values = [],
  onChange,
  value,
  alwaysShowDefaultOption,
  defaultOptionTitle,
}) => (
  <Wrapper $singleColumn={!label}>
    {label && <Label required={required}>{label}</Label>}
    <CoreSelect
      $noSpacer
      className={className}
      name={name}
      required={required}
      handler={onChange}
      currentValue={value}
      options={(values || []).map(({ value: v, label: l }) => ({
        value: v,
        name: l || v,
      }))}
      alwaysShowDefaultOption={alwaysShowDefaultOption}
      defaultOptionTitle={defaultOptionTitle}
    />
  </Wrapper>
);

export default styled(Dropdown)``;
